import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectRegionId } from '../selectors/filters';
import { selectedRoadsSelector } from '../selectors/roads/selectedRoadsSelector';
import { selectedStationsSelector } from '../selectors/stations/selectedStationsSelector';
import { isAgentSelector } from '../selectors/userData/isAgentSelector';
import { getJoinedUniqueIds } from '../components/AdfoxBanner/external/context/AdfoxContext/internal/utils';

/**
 * Набор puidN размещения, общий для легаси-баннера @cian/adfox-component
 * и микрофронтенда ad-banner-frontend: значения должны совпадать, чтобы показывалась
 * та же рекламная кампания.
 */
export function usePuids(): Record<string, string> {
  const regionId = useSelector(selectRegionId);
  const isAgent = useSelector(isAgentSelector);
  const selectedStations = useSelector(selectedStationsSelector);
  const selectedRoads = useSelector(selectedRoadsSelector);

  return useMemo(
    (): Record<string, string> => ({
      puid1: 'deal_type_sale',
      puid10: isAgent ? 'agent' : 'no_agent',
      puid2: 'offer_suburban',
      puid3: 'sale_type_first',
      puid5: `obl_id_${regionId}`,
      puid34: getJoinedUniqueIds(selectedStations),
      puid35: getJoinedUniqueIds(selectedRoads),
    }),
    [isAgent, regionId, selectedRoads, selectedStations],
  );
}
